export class RecommendedProduct extends window.BAO.CustomElement() {
  // connectedCallback () {
  //   super.connectedCallback()
  // }
  setupListeners () {
    super.setupListeners()

    if (!this.els?.select?.element) return

    this.els.select.element.addEventListener('change', this.onSelectChange.bind(this))
  }

  onSelectChange () {
    const selectedOption = this.els.select.element.selectedOptions[0]
    const notify = this.els?.notify?.element

    // Out of stock variants swap the CTA to notify me instead of adding to cart
    if (notify && selectedOption?.dataset.available === 'false') {
      notify.dataset.backInStockVariantId = selectedOption.value
      notify.dataset.backInStockVariantTitle = selectedOption.dataset.variantTitle
      notify.hidden = false
      return
    }

    if (notify) {
      notify.hidden = true
    }

    this.els.id.element.value = this.els.select.element.value
    this.els.submit.element.click()
  }
}

customElements.define('recommended-product', RecommendedProduct)
